import React from 'react';
import {Card,Button} from 'react-bootstrap'
import styled from 'styled-components'

const StyledHeader = styled(Card.Title)`
    font-size: 2rem;
    font-weight: normal;
    letter-spacing: 0.1rem;
`
const StyledAuthor = styled(Card.Title)`
    font-weight: lighter;
`
const StyledText = styled(Card.Text)`
    font-family: Lora;
    text-align: left;
    padding-top: 5%;
    font-size: 1.3rem;
`
const StyledButton = styled(Button)`
    background: rgb(65, 80, 120);
    border: rgb(65, 80, 120);
    font-weight: bold;
    width: 50%;
    font-size: 20px;
    bottom: 0;
`

const StyledCard = styled(Card)`
    font-family: "Open Sans";
    font-style: normal;
    width: 100%;
    height: 100%;
    background: rgb(232, 232, 232);
    border: 0;
`

const LongCard = ({text, title, writer, image, link}) => {
    return (
        <StyledCard>
            <div className="row" style={{ padding: '2.5rem 2rem'}}>
                <div className="col-sm-6">
                <a href={link}><Card.Img variant="top" src={image} /></a>
                </div>
                <div className="col-sm-6" style={{ 'display': 'flex', 'align-items': 'center'}}>
                    <Card.Body>
                        <a href={link} className="titlelink"><StyledHeader>{title}</StyledHeader></a>
                        <StyledAuthor>{writer}</StyledAuthor>
                        <StyledText>
                            {text}
                        </StyledText>
                        <StyledButton variant="dark" href={link} target='_blank'>Read Article</StyledButton>
                    </Card.Body>
                </div>
            </div>
        </StyledCard>
    );
}

export default LongCard;